import { styled } from "twin.macro";

export const ContentColouredText = styled.span`
  & {
    color: ${({ hex }) => (hex ? hex : "inherit")};
  }
`;
